import { UserOrgs } from "services";

export const getRoleName = (data: UserOrgs, type: "IS_LD" | "IS_PACE") => {
    const bundle = data.bundles.find((roles) => roles.flags.find((flag) => flag === type));
    return bundle;
};
